module.exports = {"id":"179897","name":"Ragnar Sigurðsson","rating":"72","photo":"./data/images/photos/4/179897.png","club":{"name":"FK Rostov","logo":"./data/images/clubs/FKRostov.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RagnarSigurðsson0.json
// module id = 3522
// module chunks = 0